import axios from "../config/axios";
import Constants from "../data/Constants";

export const getRescheduleSessions = async (filters = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.SESSION.RESCHEDULE_LIST, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};
